export default {
  CURRENCY: '¥',
  CURRENCY_CODE: 'JPY',
  isShowMessageMaintain: false,
  MAINTAIN_CODE_MESSAGE: 'WEB-MAINTAIN-MESSAGE',
  MAINTAIN_CODE_TITLE: 'WEB-MAINTAIN-TITLE',
  // COUNTRY_CODE: "MY",
  CURRENCY_FORMAT: 0, // 0.00
  CURRENCY_RGX: /(\d)(?=(\d\d\d)+(?!\d))/g,
  MAX_TOPPING: 15,
  CURRENCY_DEC_POINT: '$1,',
  COUNTRY_CODE: 'JP', // "AE",
  COUNTRY_CODE_COMPONENT: 'country:jp', // "AE",
  GOOGLE_MAP_API_KEY: 'AIzaSyDKYCZ1DFNXUqDlouh_gmdpCcd05JOxp8Q', // "AE",
  TAX_RATE: 6,
  PAYMENT_METHOD_MAYBANK_CREDIT_CARD: 'soft_bank',
  PAYMENT_METHOD_CREDIT_CARD: 'credit',
  PAYMENT_METHOD_MAYBANK2U: 5,
  PAYMENT_METHOD_CASH_ON_DELIVERY: 'cash',
  PAYMENT_METHOD_FOR_CASH_ON_DELIVERY: 1,
  PAYMENT_METHOD_MASTERPASS: 4,
  PAYMENT_METHOD_PAYPAY: 'paypay',
  REGISTRATION_CONFIRM: 'confirmation',
  REGISTRATION_LIGHT_CONFIRM: 'light-confirmation',
  COPY_RIGHT: 'Copyright',
  COPY_RIGHT_MK: 'PIZZA HUT JAPAN LTD. All Rights Reserved.',
  CORONA_LESS_CONTACT_CONTENT: '★★★置きピザご希望★★★', // [1] shift-jis = [2] (utf-8)characters
  TEL: '0120-115562',
  LIMIT_BIRTHDAY: 1900,
  MENU_DEFAULT: 'hot-deal',
  MENU_LUNCH: 'lunch-time',
  MENU_HUT_DAY: 'hut-day',
  MENU_PIZZA: 'pizzas',
  MENU_COUPON: 'coupons',
  DELIVERY: 'DELIVERY',
  CARRYOUT: 'CARRYOUT',
  DEFAULT_CONFIG_APP: 'MAP',
  DEFAULT_CONFIG_APP_2: 'Localization',
  OPEN_TIME: '10:00:00',
  CLOSE_TIME: '23:00:00',
  URL_JP: '/pc/shop_detail/',
  FULL_URL_JP: 'https://pizzahut.jp/pc/shop_detail/',
  DOMAIN_BETA: 'phjbeta.phdvasia.com',
  SWIFTYPE_HOST: 'host-eypj92',
  SWIFTYPE_API_KEY: 'search-vksfirz45gsd5mq9vvd17nry',
  SWIFTYPE_ENGINE_NAME: 'phjjp',
  HALF_HALF_ID: 2,
  HALF_HALF_SET: {
    NORMAL: 0,
    LUNCH: 1,
    BOTH: 2
  },
  HALF_HALF_PRICE: 1800,
  HALF_HALF_LUNCH_PRICE: 1300,
  HALF_HALF_LUNCH_PRICE_30: 1274,
  HALF_HALF_LUNCH_PRICE_50: 910,
  CARD_ITEM_TYPE: {SINGLE: 0, COMBO: 1, HALF: 2, FREE: 4},
  LUNCH_TIME_UUID: '48609434-44bc-3a02-9e23-d682dcbf4395',
  SPECIAL_OFFER: [
    '56a5a6e2-ae6d-408e-bb4b-3889e1170c8d',
    'a4d6ab30-7c3a-45eb-8fa7-918e7776bb3e',
    '472ab987-6648-4187-af74-50fa39763b49',
    '77f55b1d-6442-422c-99c4-6b91c61704e2',
    '3dbd6e0a-9fcf-4e56-9edb-823c9d49b045',
    'dbb5079b-4098-457a-aec8-629fc1d557d5',
    'f0c35f3a-a667-42d0-9441-9bbabcafb0fd',
    'ccee5af7-fad0-4e27-b652-ed2be81327e6',
    '15326276-4c91-4617-a49c-e3a9c7030182',
    '6f512da7-4ceb-4ac7-8315-10a2812a9f75',
    'a72939f4-94c5-4f26-9117-2ad11449a5d9',
    'a9ff2fc2-0476-415e-b4ac-fadeba742f7d',
    'bbb6a430-e654-452b-89bf-29dbb37921a4',
    '64ed84a2-39b3-48c8-8805-79fcbaea5393',
    'cf512ee8-9f49-41ec-9273-93ed34bb374a',
    'd0aa7dd4-d4d7-44e1-89a0-ae1ba105a9a0',
    '53530364-54b8-4405-affc-034719aa5b79',
    'ce8f3059-ae52-4a45-b76f-44b874113e1f',
    'c54fd0db-b1a7-4e22-a332-17d36e228386',
    '7eb9859c-aa66-44bc-bcf1-423d8e92e99a',
    'b3fc3142-9a2b-4d4c-8a1f-2442855d4107',
    '7d2fc681-cdc4-462f-add2-31c0d53e410f',
    'bd877b5e-76f2-4040-9dfa-59a70232acd7',
    '42d1e78b-db10-460e-8bf9-098dd645bb62',
    '3b14f114-8448-4545-a32f-daf40a5c231a',
    '53bd13c4-f6d0-4a04-b210-b9922ef65b35',
    'b85188b5-8ad9-435e-be2a-db50e8dd2728',
    '4886568a-5edd-4e7c-b06c-a7d6cffe5c23',
    '861bd429-56cf-42c4-9453-08c7f4b7c171',
    '90229279-796b-48be-8b17-750885916910',
    '42e2151c-5fdf-49ce-b054-3440e745cea0',
    '4b0d694d-4f15-4de5-817d-3c8584b69eb1'
  ],
  HALF_HALF_UUID: 'half-and-half',
  HALF_HALF_30_PICKUP_UUID: 'half-and-half-30-pickup',
  HALF_HALF_LUNCH_UUID: 'lunch-half-and-half',
  HALF_HALF_30_UUID: 'half-and-half-30',
  HALF_HALF_50_UUID: 'half-and-half-50',
  COUPON_UUID: '6d7faa2c-5cf4-11e9-8647-d663bd873d93',
  FACEBOOK_LOGIN: 1, // login with facebook
  GOOGLE_LOGIN: 2, // login with google +
  YAHOO_LOGIN: 3, // login with yahoo
  HUT_DAY_UUID: '8ff881a5-6cc1-4661-a678-bcf1e6e516bb',
  CATEGORY_TOPIC: 'campaigns',
  CATEGORY_COUPON: 'coupons',
  PAYMENT_COUPON_ERROR: [
    'CP-14'
  ],
  COUPON_ALLOW: {
    'CP-02': {},
    'CP-03': {'fields': ['min_cart'], 'currency': true},
    'CP-04': {},
    'CP-05': {},
    'CP-06': {},
    'CP-07': {},
    'CP-08': {},
    'CP-09': {},
    'CP-10': {},
    'CP-11': {},
    'CP-12': {},
    'CP-13': {},
    'CP-16': {},
    'CP-17': {},
    'CP-18': {'fields': ['day_of_weeks']},
    'CP-19': {},
    'CP-20': {},
    'CP-21': {},
    'CP-22': {},
    'CP-23': {},
    'CP-24': {},
    'CP-25': {'fields': ['min_cart']},
    'CP-26': {},
    'CP-30': {},
    'CP-32': {},
    'CP-33': {}
  },
  CART_CODE: {
    INVALIDHUTDAY: 'ITEM-02', NOTFOUND: 'CART-01', INVALIDLUNCHTIME: 'ITEM-03', SELLINGTIME: 'SINGLE-06',
    INVALIDORDERTIME: 'HUT-01', INVALIDOPENTIME: 'HUT-02', INVALIDMINCART: 'CART-03', EMPTYCART: 'CART-04',
    INVALIDCURRENTORDERTIME: 'CART-07',
    INVALID_PURCHASE_SPECIFIED_TIME: 'HUTFE-15',
    CART_INVALID : "CART-14",
    STORE_NOT_EXIST : "HUTFE-1"
  },
  CHECKOUT_SHOW_ASAP: {
    ORDER_0: 'ORDER-0',
    ORDER_14: 'ORDER-14',
    ORDER_19: 'ORDER-19',
    ORDER_18: 'ORDER-18',
    HUTFE_12: 'HUTFE-12',
    HUTFE_14: 'HUTFE-14'
  },
  PAYMENT_ERROR: {
    PAYMENT_4: 'PAYMENT-4',
    PAYMENT_5: 'PAYMENT-5'
  },
  GMS_EXCEPTION_CODE: ['CP-03'],
  MESSAGES_PARAMS: {
    'CP-18': {'fields': ['day_of_weeks']}
  },
  MESSAGES: {
    'ORDER-1': 'order.error_text_order_not_found',
    'ORDER-2': 'order.error_text_empty_cart_detail',
    'ORDER-3': 'order.error_text_empty_store_detail',
    'ORDER-4': 'order.error_text_single_invalid',
    'ORDER-5': 'order.error_text_not_update_use_coupon',
    'ORDER-6': 'order.error_text_apply_coupon_fail',
    'ORDER-7': 'order.error_text_not_add_item_cart',
    'ORDER-8': 'order.error_text_not_create_cart',
    'ORDER-9': 'order.error_text_invalid_order_time',
    'ORDER-10': 'order.error_text_empty_store_open_time',
    'ORDER-11': 'order.error_text_invalid_collection_time',
    'ORDER-12': 'order.error_text_store_close',
    'ORDER-14': 'order.order_14',
    'COMMON': 'cart.error_text_invalid_cart_item',
    'HUT-01': 'cart.error_text_invalid_order_time',
    'HUT-02': 'cart.error_text_invalid_open_time',
    'HUT-03': 'cart.error_text_invalid_res_info',
    'HUT-04': 'cart.error_text_call_hut_api_error',
    'CART-01': 'cart.error_text_cart_not_found',
    'CART-02': 'cart.error_text_invalid_time_quote',
    'CART-03': 'cart.error_text_invalid_min_cart',
    'CART-04': 'cart.error_text_empty_cart',
    'CART-05': 'cart.error_text_invalid_outlet_min',
    'CART-07': 'cart.error_text_invalid_curr_order_time',
    'REWARD-01': 'cart.dont_have_coupon',
    'REWARD-02': 'cart.coupon_dont_contain_coupon',
    'REWARD-03': 'cart.can_not_get_coupon',
    'REWARD-04': 'cart.invalid_reward_item',
    'REWARD-05': 'cart.coupon_expired',
    'ITEM-02': 'cart.invalid_hutday',
    'ITEM-03': 'cart.invalid_lunchtime',
    'ITEM-04': 'cart.invalid_reward_item',
    'COMBO-01': 'cart.invalid_combo_uuid',
    'COMBO-02': 'cart.invalid_combo_response',
    'COMBO-03': 'cart.invalid_selling_date',
    'GROUP-01': 'cart.invalid_group_id',
    'GROUP-02': 'cart.invalid_item_id',
    'GROUP-03': 'cart.invalid_second_id',
    'GROUP-04': 'cart.invalid_topping',
    'GROUP-05': 'cart.invalid_first_id',
    'SINGLE-01': 'cart.invalid_product_id',
    'SINGLE-02': 'cart.invalid_single_response',
    'SINGLE-03': 'cart.invalid_second_id',
    'SINGLE-04': 'cart.invalid_topping',
    'SINGLE-05': 'cart.invalid_first_id',
    'SINGLE-06': 'cart.invalid_selling_date',
    'SINGLE-07': 'cart.invalid_open_time',
    'COUPON-01': 'cart.invalid_coupon',
    'COUPON-02': 'cart.broken_coupon_link',
    'COUPON-03': 'cart.invalid_coupon_apply',
    'COUPON-04': 'cart.invalid_payment_method',
    'CUS-100001': 'customer.token_invalid',
    'CUS-100002': 'customer.customer_not_found',
    'CUS-100003': 'customer.email_exist',
    'CUS-100004': 'customer.can_not_create',
    'CUS-100005': 'customer.can_not_update',//can_not_update
    'CUS-100006': 'customer.auth_fail',
    'CUS-100007': 'customer.using_old_password',
    'CUS-100008': 'customer.can_not_create_location',
    'CUS-100009': 'customer.can_not_update_location',
    'CUS-100010': 'customer.otp_sent',
    'CUS-100011': 'customer.opt_invalid',
    'CUS-100012': 'customer.request_id_invalid',
    'CUS-100013': 'customer.otp_required',
    'CUS-100014': 'customer.data_invalid',
    'CUS-100015': 'customer.email_id_not_found',
    'CUS-100016': 'customer.can_not_create_contact',
    'CUS-100017': 'customer.location_notfound',
    'CUS-100022': 'validate_invalid_password',
    'CUS-100023': 'validate_password_no_uppercase',
    'CUS-100024': 'validate_password_no_lowercase',
    'CUS-100025': 'validate_password_no_number',
    'CUS-100026': 'validate_password_no_non_alphanumberic',
    'CUS-100027': 'validate_old_wrong_password', //VALIDATE_OLD_WRONG_PASSWORD
    'CP-01': 'coupon.exception',
    'CP-02': 'coupon.already_apply',
    'CP-03': 'coupon.minimun_amount_apply',
    'CP-04': 'coupon.invalid_open_time',
    'CP-05': 'coupon.invalid_order_type',
    'CP-06': 'coupon.invalid_condition',
    'CP-07': 'coupon.login_to_use',
    'CP-08': 'coupon.invalid_this_user',
    'CP-09': 'coupon.invalid_this_outlet',
    'CP-10': 'coupon.invalid_multiple',
    'CP-11': 'coupon.invalid_with_menu_item',
    'CP-12': 'coupon.coupon_not_found',
    'CP-13': 'coupon.invalid_order_time',
    'CP-15': 'coupon.missing_params_validation',
    'CP-16': 'coupon.quality_not_sufficient',
    'CP-17': 'coupon.only_future',
    'CP-18': 'coupon.only_weekday',
    'CP-19': 'coupon.only_hut_day',
    'CP-20': 'coupon.only_lunctime',
    'CP-21': 'coupon.item_not_applicable',
    'CP-22': 'coupon.invalid_min_amount_apply_coupon',
    'CP-23': 'coupon.invalid_limit_coupon',
    'CP-24': 'coupon.coupon_cp_24',
    'CP-25': 'coupon.minimun_item',
    'CP-26': 'coupon.coupon_cp_26',
    'CP-30': 'coupon.coupon_cp_30',
    'CP-32': 'coupon.coupon_cp_32',
    'CP-33': 'coupon.coupon_cp_33',
    'CPH-01': 'coupon.history_exception',
    'CPH-02': 'coupon.missing_params_history',
    'GA-01': 'coupon.game_unavailable',
    'GA-02': 'coupon.game_setting_empty',
    'GA-03': 'coupon.game_exceeded_play_time',
    'HUTFE-10': 'localization.notopen',

    'HUTFE-0': 'hutfe.error_text_fe_invalid_input_data',
    'HUTFE-1': 'hutfe.error_text_fe_store_not_found',
    'HUTFE-2': 'hutfe.error_text_fe_order_time_in_past',
    'HUTFE-3': 'hutfe.error_text_fe_info_accurate',
    'HUTFE-4': 'hutfe.error_text_fe_temporarily_unavailable',
    'HUT-FE-004': 'hutfe.error_text_fe_opentimes',
    'HUTFE-5': 'hutfe.error_text_fe_service_end',
    'HUTFE-6': 'hutfe.error_text_fe_address_code_not_found',
    'HUTBE-1': 'hutbe.error_text_be_store_not_found',
    'HUTBE-2': 'hutbe.error_text_be_store_group_not_found',
    'HUTBE-3': 'hutbe.error_text_be_file_invalid',
    'HUTBE-4': 'hutbe.error_text_be_store_id_invalid',
    'HUTBE-5': 'hutbe.error_text_be_select_file',
    'HUTBE-6': 'hutbe.error_text_be_file_not_found',
    'HUTBE-7': 'hutbe.error_text_be_temporarily_unavailable',
    'HUTBE-8': 'hutbe.error_text_be_service_end',
    'HUTBE-9': 'hutbe.error_text_be_call_internal_error',
    'HUTBE-0': 'hutbe.error_text_be_invalid_data'
  },
  LOCALIZATION_CODE: {
    UNAVALIABLE: 'HUTFE-4',
    NOTOPEN: 'HUTFE-10',
    NOTRECEIPT: 'HUTFE-11',
    /*ONLY FOR DEAD TRACKING*/
    DELIVERY_DEADZONE : [
      'HUTFE-19',
      'HUTFE-19-001',
      'HUTFE-19-002',
      'HUTFE-19-003',
      'HUTFE-19-004',
      'HUTFE-16',
      'HUTFE-14'
    ],
    HUT_CLOSED : [
      'HUTFE-25-001',
      'HUTFE-25-002',
      'HUTFE-25-003',
      'HUTFE-25-004',
      'HUTFE-25'],
    HUT_BOUNCING : ['HUTFE-10', 'HUTFE-5']
    /*END DEAD TRACKING*/
  },
  CUSTOMER_CODE: {INVALID: 'CUS-100001'},
  COUPON_CODE: {TOKEN_INVALID: 'CP-24'},
  COUPON_TYPE_ITEM: 1,
  COUPON_TYPE_UNIT: 2,
  COUPON_TYPE_PERCENT: 3,
  COUPON_TYPE_FREE_DELIVERY: 4,
  IMG_PIZZA_DEFAULT: 'https://static.pizzahut.jp/jp/images/1.png',
  IMG_CRUST_DEFAULT: 'https://static.pizzahut.jp/jp/images/2.png',
  FLAG_DELIVERY_FEE: false,
  COUPON_PAGE_REQUIRED_LOGIN: true,
  LANG_JP: 'ja',
  LANG_EN: 'en',
  DATA_LAYER: {
    PLATFORM: {
      'type': 'website',
      'name': 'phdv',
      'environment': '',
      'localeRegion': 'apac',
      'localeCountry': 'jp',
      'localeLanguage': 'ja',
      'currency': 'jpy'
    }
  },
  DEFAULT_SELECTED_BIRTH_YEAR: 20,
  HEADER_MENU: {
    'CAMPAIGN': 'campaigns',
    'CAMPAIGN_DETAIL': 'campaign-detail',
    'TOPIC': 'topic',
    'TOPIC_DETAIL': 'topic-detail',
    'CATEGORY': 'category',
    'COUPON': 'coupons',
    'HALF_HAlF': 'half-half',
    'HALF_HAlF_DISCOUNT': 'half-half-discount',
    'HALF_HALF_30PICKUP': 'half-and-half-30-pickup',
    'PIZZA': 'pizzas',
    'LUNCH_SET': 'lunch-set',
    'COMBO_DETAIL': 'combo-detail'
  },
  PIZZA_SLUG: 'pizzas',
  ORDER_STATUS_POS: {
    CODE: [4, 8],
    SUB_CODE: {
      '4': [100, 101, 102, 200, 201, 202, 206, 207, 400, 401, 402, 403, 500, 700, 701, 702, 703, 704, 705, 706, 900],
      '8': [999]
    }
  },
  POS_CODE_ALERT_FCDS: ['501', '502', '600', '601', '611', '612', '613', '614', '615'],
  ORDER_STATUS: {
    ERROR: [4, 22],
    STARTING: [1, 2, 25, 27],
    RECEIVED: [3, 10, 11, 12, 13, 14, 15],
    COOKING: [5],
    DELIVERING: [6],
    COMPLETED: [7, 9],
    CANCELED: [8],
    READY: [16, 17, 18, 19, 20],
    READY_TO_GO: [29]
  },
  ORDER_STATUS_IMAGE: {
    ERROR: [4, 22],
    STARTING: {
      GIF: 'https://static.pizzahut.jp/jp/icons/tracker-ani_01-chosen-alpha.gif',
      PNG: 'https://static.pizzahut.jp/jp/icons/tracker-ani_01-chosen-alpha.png'
    },
    RECEIVED: {
      GIF: 'https://static.pizzahut.jp/jp/icons/tracker-ja-accepted.gif',
      PNG: 'https://static.pizzahut.jp/jp/icons/tracker-ja-accepted.png'
    },
    COOKING: {
      GIF: 'https://static.pizzahut.jp/jp/icons/tracker-making.gif',
      PNG: 'https://static.pizzahut.jp/jp/icons/tracker-making.png'
    },
    DELIVERING: {
      GIF: 'https://static.pizzahut.jp/jp/icons/tracker-delivery.gif',
      PNG: 'https://static.pizzahut.jp/jp/icons/tracker-delivery.png'
    },
    COMPLETED: {
      GIF: 'https://static.pizzahut.jp/jp/icons/tracker-collection.gif',
      PNG: 'https://static.pizzahut.jp/jp/icons/tracker-collection.png'
    },
    CANCELED: {
      GIF: 'https://static.pizzahut.jp/jp/icons/tracker-ani_01-chosen-alpha.gif',
      PNG: 'https://static.pizzahut.jp/jp/icons/tracker-ani_01-chosen-alpha.png'
    },
    READY: {
      GIF: 'https://static.pizzahut.jp/jp/icons/tracker-collection.gif',
      PNG: 'https://static.pizzahut.jp/jp/icons/tracker-collection.png'
    }
  },
  PHONE_MIN_LENGTH: 6,
  PHONE_MAX_LENGTH: 14,
  COUPON_TYPES: {
    PROMOTION: [4, 5, 6],
    DISCOUNT: [2, 3],
    FREE_GIFT: [1],
    CIRCLE_DISCOUNT: [5]
  },
  COUPON_IMAGES: {
    PROMOTION: {
      JA: 'https://static.pizzahut.jp/jp/images/Promotion-JP-1.png',
      EN: 'https://static.pizzahut.jp/jp/images/Promotions-1.png'
    },
    DISCOUNT: {
      JA: 'https://static.pizzahut.jp/jp/images/Discount-JP-1.png',
      EN: 'https://static.pizzahut.jp/jp/images/Discount-1.png'
    },
    FREE_GIFT: {
      JA: 'https://static.pizzahut.jp/jp/images/Free-Gift-JP-1.png',
      EN: 'https://static.pizzahut.jp/jp/images/Free Gift-1.png'
    }
  },
  QUOTE_TIME_CARRYOUT: 30,
  EVENT_BUS: {
    LOADING: 'LOADING',
    LOAD_CATEGORY: 'LOAD_CATEGORY',
    RELOAD_PAGE: 'RELOAD_PAGE',
    SHOW_ASAP: 'SHOW_ASAP',
    REDIRECT_TO_MENU_PAGE: 'REDIRECT_TO_CATEGORY_PAGE',
    BACK_BUTTON_CLICK: 'BACK_BUTTON_CLICK'
  },
  TOPPING: {
    MAX_TOPPING: 15,
    MAX_PER_TOPPING: 3,
    MAX_PER_DEFAULT_TOPPING: 1,
    TYPE_DEFAULT: 1,
    TYPE_EXTRA: 2,
    MIN_PER_TOPPING: 0,
    EXTRA_TOPPING_COUNT: 0,
    DEFAULT_TOPPING_COUNT: 1,
    EXTRA: {
      ADD: 1,
      REMOVE: 0,
    },
    DEFAULT: {
      REMOVE: 1,
      READD: 0,
    }
  },
  HALF_HALF_IMAGES_DETAIL: {
    LUNCH: 'https://static.pizzahut.jp/jp/images/hh-lunch-360-990.jpg',
    NORMAL: 'https://static.pizzahut.jp/jp/images/hh-360-990.jpg'
  },
  HALF_HALF_IMAGES: {
    NORMAL_4_30: 'https://static.pizzahut.jp/jp/images/half-and-half-4_30.jpg',
    NORMAL_4_50: 'https://static.pizzahut.jp/jp/images/half-and-half-4_50.jpg',
    NORMAL_2_30: 'https://static.pizzahut.jp/jp/images/674_240_1001RED_otoku30_H_H.jpg',
    NORMAL_2_50: 'https://static.pizzahut.jp/jp/images/674_240_1001RED_otoku50_H_H.jpg',
    NORMAL_4: 'https://static.pizzahut.jp/jp/images/half-and-half.png',
    NORMAL_2: 'https://static.pizzahut.jp/jp/images/half-and-half-3.jpg',
    LUNCH_4: 'https://static.pizzahut.jp/jp/images/Lunch_H&H.png',
    LUNCH_2: 'https://static.pizzahut.jp/jp/images/FCDS674_240_LUNCH_HH_A.jpg',
    CATEGORY: 'https://static.pizzahut.jp/jp/images/half_half_category.png'
  },
  IMAGES: {
    HOME_CARD_CORONA: 'https://static.pizzahut.jp/jp/images/oki_pizza556_100_2.jpg',
    HOME_CARD_CORONA_2:
    "https://static.pizzahut.jp/jp/images/FCDS_TOP_556_100.jpg",
    HOME_CARD_S: 'https://static.pizzahut.jp/jp/images/556_100_REWARDS.jpg',
    HOME_CARD: 'https://static.pizzahut.jp/jp/images/home-cards5.jpg',
    HOME_TEXT_TOP: 'https://static.pizzahut.jp/jp/images/home-text-jp.png',
    HOME_TEXT_TOP_DEFAULT: 'https://static.pizzahut.jp/jp/images/home-text-default.png',
    HUT_TEXT_1: 'https://static.pizzahut.jp/jp/images/Store-3.png',
    HUT_TEXT_2: 'https://static.pizzahut.jp/jp/images/Store-2.png',
    HUT_TEXT_3: 'https://static.pizzahut.jp/jp/images/Store-1.png',
    HUT_TEXT_4: 'https://static.pizzahut.jp/jp/images/block-hutday-outlet.png',
    COUPON_POPUP_EN: 'https://static.pizzahut.jp/jp/images/coupon-popup-en.png',
    COUPON_POPUP_JP: 'https://static.pizzahut.jp/jp/images/coupon-popup-jp.png'
  },
  URL_TOPIC_OKIPIZZA: 'https://pizzahut.jp/topic/okipizza/service',
  URL_TOPIC_OKIPIZZA_2: "https://www.pizzahut.jp/topic/pizza/zenpin",
  URL_CASHLESS: 'https://www.pizzahut.jp/hutrewards',
  HALF_HALF_EXCLUDE_STORE: [],
  NON_LOCALIZATION_CATEGORY: [],
  SLUG_LIST: {
    PIZZA: ['pizza', 'pizzas'],
    DEAL: ['hot-deal']
  },
  FORMAT_CODE: {
    'UTF8': 'utf-8',
    'JIS': 'shift-jis'
  },
  TIMEOUT_CART: 6,
  NON_NOTIFY: ['payment-status'],
  ONE_LINK: 'http://onelink.to/5gwjzq',
  PASSWORD_MIN: 8,
  CHARSET_RULE: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789~!@#$%^&*_-+=`|\\(){}[]:;“’<>,.?/",
  TAX: {
    TAX8: 8,
    TAXRATE8: 1.08,
    TAXRATE10: 1.10,
    TAX10: 10
  },
  PROFILE_LOGIN: 'log-in',
  TRACKER_ORDER_ERR: {
    STORE_CLOSED: 'ERR-ONLPAY-29',
    OVER_LIMITED_TIME: 'ERR-ONLPAY-28',
    CHEATING_DELIVERY_TIME: 'ERR-ONLPAY-19',
  },
  CREDITCARD_TIMEOUT: 1200, // Second,
  EXPIRED_DATE: 46, // days
  FRANCHISING_LINK: 'https://corp.pizzahut.jp/franchise/',
  CODE_WEB_MESSAGE: 'IN-WEB',
  CODE_PONTA_MESSAGE: 'WEB-PONTA-MESSAGE',
  CODE_GREEN_CHILLI: 'WEB-GREEN-CHILLI',
  CODE_GREEN_CHILLI_CHECKOUT: 'WEB-GREEN-CHILLI-CHECKOUT',
  ACTION_LOGIN: '/product-customer/fe-login',
  ACTION_REGISTER: '/product-customer/fe-registration',
  DEFAULT_OUTLET: '8666',
  LIMIT_VIEW_MORE: 3,
  CLASS_RANKING: {
    1: 'rank-vip',
    2: 'rank-gold',
    3: 'rank-silver',
    4: 'rank-member',
    5: 'rank-no-member-1',
    6: 'rank-no-member-2'
  },
  CODE_RANKING: {
    1: 'VIP',
    2: 'GOLD',
    3: 'SILVER',
    4: 'MEMBER',
    5: 'MEMBER',
    6: 'MEMBER'
  },
  CODE_EVENT_LOYALTY: {
    BIRTHDAY: 'BIRTHDAY', ANNIVERSARY: 'ANNIVERSARY', REGISTRATION: 'REGISTRATION', RANK_UP: 'RANK_UP', REGULAR_GRANT_SLICE: 'REGULAR_GRANT_SLICE', APP_GAME_WINNER: 'APP_GAME_WINNER'
  },
  AB_TESTING_FUNCTIONAL: [{
    name: "reOrderLastOrder",
    goal: "CVR",
    expiry: "2022-01-01",
    variants: [
      {
        title: "showLastOrder",
        value: "1"
      },
      {
        title: "notShowLastOrder",
        value: "0"
      },
    ]
  },
  {
    name: 'newDisposition',
    goal: 'CVR',
    expiry: '2090-04-04',
    variants: [
      {
        title: 'clickToOpenPopup',
        value: 1
      }
    ]
  }
  ],
  SLICE_DEFAULT: 1000,
  ACTION_CODE: 'app-game-benefit-grant-slice',
  TIMEZONE: 'Asia/Tokyo',
  GAME_CODE_GET_SLICE: 'add_slice',
  IMG_GAME_COUPON_DEFAULT: 'https://static.pizzahut.jp/jp/images/Free Gift-1.png',
  IMG_GAME_FREE_SLICE: 'https://static.phdvasia.com/jp/hut-rewards/hut-rewards-get-slice.jpeg'
}



// WEBPACK FOOTER //
// ./src/constants.js